"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var _reactRouterDom = require("react-router-dom");

var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    NavTopBarLink: theme.NavTopBarLink,
    NavTopBarLinkActive: theme.NavTopBarLinkActive,
    NavTopBarLink_Indicator_Inactive: theme.NavTopBarLink_Indicator_Inactive,
    NavTopBarLink_Indicator_Active: theme.NavTopBarLink_Indicator_Active,
    NavTopBarLinkContent: theme.NavTopBarLinkContent
  };
});
/**
 * Create a NavLink Element for the NavTopBar
 */

var _ref = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);

var NavTopBarLink = /*#__PURE__*/_react["default"].forwardRef(function NavTopBarLink(props, ref) {
  var Show = props.Show,
      Slug = props.Slug,
      exact = props.exact,
      WithActiveIndicator = props.WithActiveIndicator,
      ClassOverrideTopNavLink = props.ClassOverrideTopNavLink,
      ClassExtendTopNavLink = props.ClassExtendTopNavLink,
      ClassOverrideTopNavLinkActive = props.ClassOverrideTopNavLinkActive,
      ClassExtendTopNavLinkActive = props.ClassExtendTopNavLinkActive,
      ClassExtendNavTopBarLink_Indicator_Inactive = props.ClassExtendNavTopBarLink_Indicator_Inactive,
      ClassExtendNavTopBarLink_Indicator_Active = props.ClassExtendNavTopBarLink_Indicator_Active,
      ClassOverrideNavTopBarLinkContent = props.ClassOverrideNavTopBarLinkContent,
      ClassExtendNavTopBarLinkContent = props.ClassExtendNavTopBarLinkContent,
      children = props.children,
      onClick = props.onClick;
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  var match = (0, _reactRouterDom.useRouteMatch)(Slug);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      IsActiveLink = _React$useState2[0],
      setIsActiveLink = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (match) {
      if (exact) {
        if (match.isExact) {
          setIsActiveLink(true);
        } else {
          setIsActiveLink(false);
        }
      } else {
        setIsActiveLink(true);
      }
    } else {
      setIsActiveLink(false);
    }
  }, [match, exact]);

  var FinalClassTopNavLink;

  if (ClassOverrideTopNavLink) {
    FinalClassTopNavLink = ClassOverrideTopNavLink;
  } else {
    if (WithActiveIndicator) {
      FinalClassTopNavLink = (0, _clsx["default"])(classes.NavTopBarLink, classes.NavTopBarLink_Indicator_Inactive, ClassExtendTopNavLink, ClassExtendNavTopBarLink_Indicator_Inactive);
    } else {
      FinalClassTopNavLink = (0, _clsx["default"])(classes.NavTopBarLink, ClassExtendTopNavLink);
    }
  }

  var FinalClassTopNavLinkActive;

  if (ClassOverrideTopNavLinkActive) {
    FinalClassTopNavLinkActive = ClassOverrideTopNavLinkActive;
  } else {
    if (WithActiveIndicator) {
      FinalClassTopNavLinkActive = (0, _clsx["default"])(classes.NavTopBarLinkActive, classes.NavTopBarLink_Indicator_Active, ClassExtendTopNavLinkActive, ClassExtendNavTopBarLink_Indicator_Active);
    } else {
      FinalClassTopNavLinkActive = (0, _clsx["default"])(classes.NavTopBarLinkActive, ClassExtendTopNavLinkActive);
    }
  }

  var FinalLinkClass = FinalClassTopNavLink;

  if (IsActiveLink) {
    FinalLinkClass = (0, _clsx["default"])(FinalLinkClass, FinalClassTopNavLinkActive);
  }

  var FinalComponent = function FinalComponent() {
    if (!Show) {
      return _ref;
    } else {
      if (Slug) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: "".concat(Slug),
          ref: ref,
          className: FinalLinkClass
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: ClassOverrideNavTopBarLinkContent ? ClassOverrideNavTopBarLinkContent : (0, _clsx["default"])(classes.NavTopBarLinkContent, ClassExtendNavTopBarLinkContent)
        }, children));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: ref,
          className: FinalClassTopNavLink,
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: ClassOverrideNavTopBarLinkContent ? ClassOverrideNavTopBarLinkContent : (0, _clsx["default"])(classes.NavTopBarLinkContent, ClassExtendNavTopBarLinkContent)
        }, children));
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement(FinalComponent, null);
});

NavTopBarLink.defaultProps = {
  Show: true,
  Slug: null,
  exact: false,
  SlugList: null,
  WithActiveIndicator: false,
  ClassOverrideTopNavLink: null,
  ClassExtendTopNavLink: null,
  ClassOverrideTopNavLinkActive: null,
  ClassExtendTopNavLinkActive: null,
  ClassExtendNavTopBarLink_Indicator_Inactive: null,
  ClassExtendNavTopBarLink_Indicator_Active: null,
  ClassOverrideNavTopBarLinkContent: null,
  ClassExtendNavTopBarLinkContent: null
};
process.env.NODE_ENV !== "production" ? NavTopBarLink.propTypes = {
  /**
   * Show or Hide the Link
   * Default is true, if false, the component is not created (not just hidden)
   */
  Show: _propTypes["default"].bool,

  /**
   * The relative link to the page to display
   * If no Slug is passed, then it will just be a button type component
   */
  Slug: _propTypes["default"].string,

  /**
   * The relative link to the page to display
   * If no Slug is passed, then it will just be a button type component
   */
  exact: _propTypes["default"].bool,

  /**
   * An array containing all the slugs that should render the Controller Active
   */
  SlugList: _propTypes["default"].array,

  /**
   * Add an Indicator or not on top of the SideBar (border) when the link is active
   */
  WithActiveIndicator: _propTypes["default"].bool,

  /**
   * Override the class
   */
  ClassOverrideTopNavLink: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendTopNavLink: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideTopNavLinkActive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendTopNavLinkActive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarLink_Indicator_Inactive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarLink_Indicator_Active: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarLinkContent: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarLinkContent: _propTypes["default"].string
} : void 0;
var _default = NavTopBarLink;
exports["default"] = _default;